(function(){'use strict';
// Pinch-zoom + pan for product images on GLASS pages.
// The product image has pointer-events:none so taps fall through to the 3D
// viewer; elementsFromPoint respects pointer-events:none, so we hit-test by
// iterating [data-pinch-zoom] nodes and checking getBoundingClientRect.
const SEL='[data-pinch-zoom]';
const MIN=1,MAX=4;
const state=new WeakMap();
let active=null;

function dist(a,b){return Math.hypot(b.clientX-a.clientX,b.clientY-a.clientY)}
function mid(a,b){return{x:(a.clientX+b.clientX)/2,y:(a.clientY+b.clientY)/2}}
function inRect(x,y,r){return x>=r.left&&x<=r.right&&y>=r.top&&y<=r.bottom}
function findTarget(touches){
  const nodes=document.querySelectorAll(SEL);
  if(!nodes.length)return null;
  const pts=[];
  for(let i=0;i<touches.length;i++)pts.push({x:touches[i].clientX,y:touches[i].clientY});
  if(touches.length>=2)pts.push(mid(touches[0],touches[1]));
  // Prefer an already-zoomed element: a fresh finger on a scaled image would
  // otherwise lose to an un-scaled sibling with a smaller rect.
  for(const el of nodes){
    const s=state.get(el);
    if(!s||s.scale<=1.01)continue;
    const r=el.getBoundingClientRect();
    if(r.width===0&&r.height===0)continue;
    for(const p of pts){if(inRect(p.x,p.y,r))return el}
  }
  // Otherwise pick the smallest-area match — prefers an inner <img> over a
  // parent container that also has [data-pinch-zoom].
  let best=null,bestArea=Infinity;
  for(const el of nodes){
    const r=el.getBoundingClientRect();
    if(r.width===0&&r.height===0)continue;
    let hit=!1;
    for(const p of pts){if(inRect(p.x,p.y,r)){hit=!0;break}}
    if(!hit)continue;
    const a=r.width*r.height;
    if(a<bestArea){best=el;bestArea=a}
  }
  return best;
}
function init(el){
  let o=state.get(el);
  if(o)return o;
  o={scale:1,tx:0,ty:0};
  state.set(el,o);
  el.style.transformOrigin='center center';
  el.style.willChange='transform';
  return o;
}
function apply(el,o){el.style.transform='translate('+o.tx+'px,'+o.ty+'px) scale('+o.scale+')'}
function zoomBox(el){return el.closest?el.closest('#PRODUCT_IMAGE'):null}
function lift(el){
  // Only promote statics: #ProductImageFullres is absolutely positioned, and
  // forcing position:relative dropped it into flow (layout jump on pinch).
  if(getComputedStyle(el).position==='static')el.style.position='relative';
  el.style.zIndex='1000';
  // The mobile media stack clips the square (overflow:hidden), which would
  // confine the zoom to the thumbnail-sized box; let it grow past the frame.
  const b=zoomBox(el);if(b)b.classList.add('decoy-zooming')
}
function unlift(el){
  el.style.zIndex='';el.style.position='';
  const b=zoomBox(el);if(b)b.classList.remove('decoy-zooming')
}
function reset(el,o){
  o.scale=1;o.tx=0;o.ty=0;
  el.style.transition='transform .25s ease-out';
  el.style.transform='';
  setTimeout(function(){el.style.transition='none';unlift(el)},260);
}
function onStart(e){
  const prev=active;
  const el=prev?prev.el:findTarget(e.touches);
  if(!el)return;
  const o=prev?prev.o:init(el);
  // 1-finger touches only get intercepted when already zoomed (for panning).
  // Plain taps on un-zoomed images must pass through for scroll / clicks.
  if(e.touches.length<2&&o.scale<=1.01)return;
  e.stopImmediatePropagation();e.preventDefault();
  if(!prev)lift(el);
  el.style.transition='none';
  if(e.touches.length>=2){
    active={el:el,o:o,mode:'pinch',startDist:dist(e.touches[0],e.touches[1]),startScale:o.scale,startMid:mid(e.touches[0],e.touches[1]),startTx:o.tx,startTy:o.ty};
  }else{
    const t=e.touches[0];
    active={el:el,o:o,mode:'pan',startMid:{x:t.clientX,y:t.clientY},startTx:o.tx,startTy:o.ty};
  }
}
function onMove(e){
  if(!active)return;
  const o=active.o;
  if(active.mode==='pinch'&&e.touches.length>=2){
    e.stopImmediatePropagation();e.preventDefault();
    const nd=dist(e.touches[0],e.touches[1]);
    const nm=mid(e.touches[0],e.touches[1]);
    o.scale=Math.max(MIN,Math.min(MAX,active.startScale*(nd/active.startDist)));
    o.tx=active.startTx+(nm.x-active.startMid.x);
    o.ty=active.startTy+(nm.y-active.startMid.y);
    apply(active.el,o);
  }else if(active.mode==='pan'&&e.touches.length>=1){
    e.stopImmediatePropagation();e.preventDefault();
    const t=e.touches[0];
    o.tx=active.startTx+(t.clientX-active.startMid.x);
    o.ty=active.startTy+(t.clientY-active.startMid.y);
    apply(active.el,o);
  }
}
function onEnd(e){
  if(!active)return;
  e.stopImmediatePropagation();
  if(e.touches.length===0){
    reset(active.el,active.o);
    active=null;
  }else if(e.touches.length===1&&active.mode==='pinch'){
    // Dropped from 2 fingers to 1 — switch into pan mode so the user can
    // keep dragging with a single finger without releasing.
    const t=e.touches[0];
    active.mode='pan';
    active.startMid={x:t.clientX,y:t.clientY};
    active.startTx=active.o.tx;active.startTy=active.o.ty;
  }
}
function onGesture(e){
  // Block iOS Safari's native page-level pinch gesture events.
  e.stopImmediatePropagation();
  try{e.preventDefault()}catch(_){}
}

const opts={capture:!0,passive:!1};
document.addEventListener('touchstart',onStart,opts);
document.addEventListener('touchmove',onMove,opts);
document.addEventListener('touchend',onEnd,opts);
document.addEventListener('touchcancel',onEnd,opts);
document.addEventListener('gesturestart',onGesture,opts);
document.addEventListener('gesturechange',onGesture,opts);
document.addEventListener('gestureend',onGesture,opts);
})();
